import { useCustomerTags } from "../admin/dictionaries/useCustomerTags";
import { groupBy } from "lodash";

export const useCustomerTagsByCategory = () => {
  const { tags } = useCustomerTags();
  return Object.fromEntries(
    Object.entries(
      groupBy(
        tags.filter((t) => t.name !== null),
        (t) => t.category,
      ),
    ).map(([k, v]) => [k, v.map((t) => t.name)]),
  );
};
